import { initializeApp } from 'firebase/app'
import { constantsExtra } from '../constants/constantsExtra'

// Note: extra.firebaseConfig and config are set in app.config.ts
export const app = initializeApp(constantsExtra.firebaseConfig)
